<ng-container *ngIf="contract">
  <p-panel [toggleable]="true">
    <p-header><i class="fas fa-file-contract"></i> {{contract.abbreviatedTitle}}</p-header>
    <div class="row" *ngIf="isLoaded()">
      <dl class="col-12 col-sm-6 p-0 m-0">
        <!-- <ng-container *ngIf="contract?.">
        <dt class="col-12 col-md-6 d-inline-block">{{ 'Nº EXPEDIENTE' | translate }}</dt>
        <dd class="col-12 col-md-6 d-inline-block">{{ contract. }}</dd>
      </ng-container> -->
        <ng-container>
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Sistema Inscripción Contrato' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{(contract.isProjectReplyca)?'REPLYCA':'RECON'}}</dd>
        </ng-container>
        <ng-container *ngIf="contract?.registrationNumber">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Contracts.registerNumber' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ contract.registrationNumber }}</dd>
        </ng-container>
        <ng-container *ngIf="contract?.contractLots[0]?.lot && contract?.contractLots[0]?.lot.lotId!== 0">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Lote ' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ contract.contractLots[0].lot.lotNumber }}</dd>
        </ng-container>
        <ng-container *ngIf="isCBAM && contract?.userOrderNumber">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Nº de orden interno del Contrato Basado' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ contract.userOrderNumber }}</dd>
        </ng-container>
        <!-- centro seccion y unidad de contratacion-->
        <ng-container
          *ngIf="contract?.organizationalInfo?.centerSectionCode && contract?.organizationalInfo?.centerSectionCode.description">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Centro - seccion' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ contract?.organizationalInfo?.centerSectionCode.description }}
          </dd>
        </ng-container>
        <ng-container
          *ngIf="contract?.organizationalInfo?.contractingUnit && (contract?.organizationalInfo?.contractingUnit.name || contract?.organizationalInfo?.contractingUnit.identifier) ">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Unidad de contratación' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">
            {{(contract.isProjectReplyca)?contract?.organizationalInfo?.contractingUnit.name:contract?.organizationalInfo?.contractingUnit.identifier}}
          </dd>
          <!--<dd class="col-12 col-md-6 d-inline-block">{{contract?.organizationalInfo?.contractingUnit.name }}</dd>-->
        </ng-container>
        <!--<ng-container *ngIf="contract?.contractLots[0]?.lot && contract?.contractLots[0]?.lot.lotId== 0">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Título abreviado del expediente' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ contract.procurementProjectInfo.abbreviatedTitle }}</dd>
        </ng-container>
        <ng-container
          *ngIf="contract?.contractLots[0]?.lot && contract?.contractLots[0]?.lot.lotId!== 0 && contract?.abbreviatedTitle">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Título Abreviado del lote' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block"> {{ contract.abbreviatedTitle }} </dd>
        </ng-container>-->
        <ng-container
          *ngIf="isCBAM && contract?.contractLots[0]?.lot && contract?.contractLots[0]?.lot.lotId!== 0 && contract?.procurementProjectInfo.title">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Título Abreviado del Contrato Basado' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ contract.procurementProjectInfo.title }}</dd>
        </ng-container>
        <ng-container *ngIf="contract?.plannedPeriod.registrationDate">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Fecha de Inscripción' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block"> <i class="fas fa-calendar-alt"></i> {{
            contract?.plannedPeriod.registrationDate | date:'dd/MM/yyyy'}} </dd>
        </ng-container>
      </dl>
      <dl class="col-12 col-sm-6 p-0 m-0">
        <!-- <ng-container *ngIf="contract?.identifier">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Unidad de Contratación.' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block"> - </dd>
        </ng-container>

        <ng-container *ngIf="contract?.identifier">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Centro - Sección' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block"> - </dd>
        </ng-container> -->
        <!-- Datos del adjudicatario -->
        <ng-container *ngIf="actualCompanyDoc">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'NIF/CIF del adjudicatario' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block"><i class=" far fa-credit-card"></i> {{
            actualCompanyDoc.taxIdentifier }}</dd>
        </ng-container>
        <ng-container *ngIf="actualCompanyDoc">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Nombre o den. social del adjudicatario' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ actualCompanyDoc.name }}</dd>
        </ng-container>
        <ng-container *ngIf="actualCompanyDoc">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Tipo persona' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">
            <ng-container *ngIf="actualCompanyDoc?.companyTypeDesc">
              {{ actualCompanyDoc.companyTypeDesc }}
            </ng-container>
            <ng-container *ngIf="contract?.company?.society?.description">- {{ contract.company.society.description }}
            </ng-container>
          </dd>
        </ng-container>
        <ng-container *ngIf="actualCompanyDoc?.nationalityDesc">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'Nacionalidad del adjudicatario' | translate }}</dt>
          <dd class="col-12 col-md-6 d-inline-block">{{ actualCompanyDoc.nationalityDesc }}</dd>
        </ng-container>
        <ng-container *ngIf="actualCompanyDoc?.pyme">
          <dt class="col-12 col-md-6 d-inline-block">{{ 'PYME' | translate }}</dt>
          <!--<dd class="col-12 col-md-6 d-inline-block">{{ contract.contractClassification.pyme }}</dd>-->
          <dd class="col-12 col-md-6 d-inline-block">{{(actualCompanyDoc?.pyme)?'Sí':'No'}}</dd>
        </ng-container>
        <ng-container *ngIf="actualCompanyDoc?.temporaryConsortium">
          <p-panel>
            <p-header>Componentes de la UTE</p-header>
            <!--<dd class="col-6">{{ contract.company.temporaryConsortium }}</dd>-->
            <p-table #dt [value]="actualCompanyDoc?.consortiumParticipations" [paginator]="false" [scrollable]="false"
              [resizableColumns]="true">
              <!-- sortField="expedienteId" sortOrder="1"
            >-->
              <ng-template pTemplate="header">
                <tr>
                  <th [pSortableColumn]="'name'"> {{ 'Nombre' | translate }} </th>
                  <th [pSortableColumn]="'taxIdentifier'"> {{ 'NIF/CIF' | translate }} </th>
                  <th [pSortableColumn]="'typeDesc'"> {{ 'Tipo Persona' | translate }} </th>
                  <th [pSortableColumn]="'nacionalidad'"> {{ 'Nacionalidad' | translate }} </th>
                  <th [pSortableColumn]="'percentage'"> {{ 'Porcentaje' | translate }} </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-consortiumParticipation>
                <tr>
                  <td field="name"> {{consortiumParticipation.name}} </td>
                  <td field="taxIdentifier"> {{consortiumParticipation.taxIdentifier}} </td>
                  <td field="typeDesc"> {{consortiumParticipation.typeDesc}} </td>
                  <td field="nationalityDesc">
                    {{ consortiumParticipation.nationalityDesc}} </td>
                  <td field="percentage"> {{consortiumParticipation.percentage}}%</td>
                </tr>
              </ng-template>
            </p-table>
          </p-panel>
        </ng-container>
      </dl>
    </div>
  </p-panel>
</ng-container>